import { LRUCache } from "lru-cache";
// src/modules/Files/utils/get-file-metadata-from-url.ts
var cache = new LRUCache({ max: 100 });
/**
* This util is tried & tested on S3 file urls. It's not guaranteed to work with other file urls (server response dependent)
*/
var getFileMetadataFromUrl = (url) => {
	if (cache.get(url)) return {
		abortPromise: () => null,
		promise: Promise.resolve(cache.get(url))
	};
	const abortController = new AbortController();
	return {
		abortPromise: () => abortController.abort(),
		promise: fetch(url, {
			credentials: "omit",
			headers: {
				accept: "*/*",
				"cache-control": "no-cache",
				pragma: "no-cache"
			},
			method: "HEAD",
			mode: "cors",
			signal: abortController.signal
		}).then((res) => {
			if (res.status < 400 || res.ok) {
				const date = res.headers.get("last-modified") || (/* @__PURE__ */ new Date()).toISOString();
				const name = res.headers.get("x-amz-meta-filename") || res.headers.get("x-amz-meta-name") || url;
				const type = res.headers.get("content-type") || "unknown";
				const val = {
					modifiedDate: date,
					name,
					size: res.headers.get("content-length") || "0",
					type,
					url
				};
				cache.set(url, val);
				return val;
			}
		}).catch((err) => {
			if (!abortController.signal.aborted) throw err;
		})
	};
};
export { getFileMetadataFromUrl };

//# sourceMappingURL=get-file-metadata-from-url.js.map